import * as React from 'react'
import styled from 'styled-components'

import { Box, Icon, Button, TextBody, Space } from '@ally/metronome-ui'
import { muiSuccessFill } from '@ally/metronome-icons'
import { InformationScreen, InformationScreenType } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../TransmitContext'

const StyledBox = styled(Box)`
  ${({ theme: { media } }): string => `
    ${media.up('lg')} {
      display: flex;
      justify-content: space-between;
    }
  `}
`

const StyledMsgWrapper = styled(Box)`
  ${({ theme: { media } }): string => `
    ${media.up('lg')} {
      width: ${(7 / 12) * 100}%; // based on a 12 column grid
    }
  `}
`

const Content: React.FC<{ activeScreen: InformationScreen }> = ({
  activeScreen,
}) => (
  <StyledBox data-testid="password-updated-page-wrapper">
    <StyledMsgWrapper data-testid="password-updated-msg-wrapper">
      <Box>
        <LoginHeading title="Password changed" />
        <Box display="flex" flexDirection="column" mb="sm">
          <Box display="flex" alignItems="flex-start" mb="xs">
            <Icon icon={muiSuccessFill} fill="success" size="lg" />
            <Space ml="xs">
              <TextBody size="sm" tag="span">
                You successfully updated your password and password hint.
              </TextBody>
            </Space>
          </Box>

          <Box mb="lg" ml="lg">
            <Space ml="xxs">
              <TextBody tag="span" size="sm">
                You can change them any time in your <b>Profile and Settings</b>
                . Now, go do your thing
              </TextBody>
            </Space>
          </Box>
          <Button
            withAllyTM="passwordChanged-goToSnapshot"
            variant="primary"
            text="Go to Snapshot"
            onClick={activeScreen.payload.onComplete}
          />
        </Box>
      </Box>
    </StyledMsgWrapper>
  </StyledBox>
)

export const PasswordUpdated: React.FC = () => {
  const { activeScreen, hostServices } = useTransmit()

  React.useEffect(() => {
    if (activeScreen.type === InformationScreenType.PasswordUpdated) {
      hostServices?.analytics.trackPageView({
        eventType: 'pageview',
        pageName: 'AOS:Login:Forgot Password:Password Updated',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeScreen.type])

  if (activeScreen.type !== InformationScreenType.PasswordUpdated) {
    return null
  }

  return (
    <>
      <Content activeScreen={activeScreen} />
    </>
  )
}
